import GameDetailsContentBoard from './Board';
import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import { useGameReportData } from '@/hooks/gameReport/useGameReportData';
import { Copy, FormGroup, Input } from '@starsoft/common/components';
import GameReportModalContentMinesDetails from './MinesDetails';
import { useNotificationService } from '@/hooks/notifications/useNotificationService';

export default function GameDetailsContent() {
  const { t } = useTranslation('game-report');
  const { randomness } = useGameReportData();
  const { NotificationsService } = useNotificationService();

  function onCopy() {
    NotificationsService.success({
      title: 'copy_base_title',
      message: 'copy_deposit_address',
    });
  }
  return (
    <div className={styles.container}>
      <GameDetailsContentBoard />
      <GameReportModalContentMinesDetails />
      <FormGroup label={t('server_seed_label')}>
        <Copy
          label={randomness?.hashedServerSeed ?? ''}
          textToCopy={randomness?.hashedServerSeed ?? ''}
          secondaryStyles
          callback={onCopy}
        />
      </FormGroup>

      <FormGroup label={t('client_seed_label')}>
        <Copy
          label={randomness?.hashedClientSeed ?? ''}
          textToCopy={randomness?.hashedClientSeed ?? ''}
          secondaryStyles
          callback={onCopy}
        />
      </FormGroup>

      <FormGroup label={t('nonce_label')}>
        <Input value={randomness?.nonce} readOnly isContainerColor />
      </FormGroup>
    </div>
  );
}
